console.log('hello esri')
function loadScript(url) {
  const script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);

  return new Promise((result, rejection) => {
    script.onload = () => result();
    script.onerror = () => rejection();
  })
}

function initEsri(gjConfig) {
    require([
      "esri/config",
      "esri/Map",
      "esri/views/MapView",
      "esri/WebMap",
      "esri/widgets/ScaleBar",
      "esri/widgets/Legend",
      "esri/WebScene",
      "esri/views/SceneView",
      "esri/widgets/Popup"
    ], function(esriConfig, Map, MapView, WebMap, ScaleBar, Legend, WebScene, SceneView, Popup) {
      esriConfig.apiKey = "AAPK31e048df826a49d4bffdc73f0999aa9c6zsVcYjaSdGjlxn1xnS4CMXeRUqqLVEb6Bfyh4hUNFeKkCWtQVA-KASfcCNiAaFk";

      if (!gjConfig.webmap) {
        const map = new Map({
          basemap: gjConfig.basemap // basemap styles service "arcgis/topographic"
        });
        
        const view = new MapView({
          map: map,
          center: [-118.805, 34.027], // Longitude, latitude
          zoom: 13, // Zoom level
          container: "viewDiv" // Div element
        });
      } else {
        // const map = new WebScene({
        //   portalItem: {
        //     id: gjConfig.webmap
        //   }
        // });
        const map = new WebMap({
          portalItem: {
            id: gjConfig.webmap // demo: 41281c51f9de45edaf1c8ed44bb10e30
          }
        });
        
        const view = new MapView({
          map,
          popup: new Popup({
            dockEnabled: true,
            dockOptions: {
              // Disables the dock button from the popup
              buttonEnabled: false,
              // Ignore the default sizes that trigger responsive docking
              breakpoint: false
            },
            visibleElements: {
              closeButton: false
            }
          }),
          container: "viewDiv" // Div element
        });
        // const view = new SceneView({
        //   container: "viewDiv",
        //   qualityProfile: "high",
        //   map: map,
        //   alphaCompositingEnabled: true,
        //   highlightOptions: {
        //     fillOpacity: 0,
        //     color: "#ffffff"
        //   },
        //   constraints: {
        //     altitude: {
        //       min: 700000
        //     }
        //   },
        //   environment: {
        //     background: {
        //       type: "color",
        //       color: [0, 0, 0, 0]
        //     },
        //     lighting: {
        //       type: "virtual"
        //     }
        //   }
        // });

        if (gjConfig.scalebar) {
          const scalebar = new ScaleBar({
            view: view
          });
    
          view.ui.add(scalebar, "bottom-left");
        }

        if (gjConfig.legend) {
          const legend = new Legend ({
            view: view
          });
          view.ui.add(legend, "top-right");
        }
      }
    });
}

loadScript('https://js.arcgis.com/4.29/')
  .then(() => {
    console.log('loaded esri');
    const gjViewElement = document.querySelector('#viewDiv');
    if (!gjViewElement) return;
    const gjConfig = {
      basemap: gjViewElement.dataset.esriBasemap ?? "arcgis/topographic",
      webmap: gjViewElement.dataset.esriWebmap,
      clickLoad: gjViewElement.dataset.clickLoad === 'true' ? true : false,
      legend: gjViewElement.dataset.legend === 'true' ? true : false,
      scalebar: gjViewElement.dataset.scalebar === 'true' ? true : false
    }

    if (gjConfig.clickLoad) {
      console.log('waiting for click');
      const gjClickElement = document.querySelector('#esri-wait-to-load');
      gjClickElement.addEventListener("click", (event) => {
        gjClickElement.remove();
        initEsri(gjConfig);
      });
      
    } else {
      initEsri(gjConfig);
    }
  })
  .catch(() => {
    console.error('Failed to load esri')
  })